import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Input,
  Label,
  toast,
} from "@devhop/ui";
import { KeyRound } from "lucide-react";
import { type FormEvent, useEffect, useState } from "react";
import { authClient } from "../api/client";
import { PIN_MAX_LENGTH } from "../lib/pin-login-shared";

const MIN_PIN_LEN = 4;

export function AdminChangePinDialog() {
  const [open, setOpen] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) return;
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
  }, [open]);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (
      newPassword.length < MIN_PIN_LEN ||
      newPassword.length > PIN_MAX_LENGTH
    ) {
      toast.error(`PIN ໃໝ່ຕ້ອງມີ ${MIN_PIN_LEN}–${PIN_MAX_LENGTH} ໂຕ`);
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("PIN ໃໝ່ກັບຢືນຢັນບໍ່ກົງກັນ");
      return;
    }

    setSubmitting(true);
    await authClient.changePassword(
      {
        currentPassword,
        newPassword,
        revokeOtherSessions: true,
      },
      {
        onSuccess: () => {
          toast.success("ປ່ຽນ PIN ຜູ້ຄຸ້ມຄອງສໍາເລັດ");
          setOpen(false);
        },
        onError: (ctx) => {
          toast.error(
            ctx.error.message || "ບໍ່ສາມາດປ່ຽນ PIN ໄດ້ — ກວດ PIN ປັດຈຸບັນໃຫ້ຖືກຕ້ອງ",
          );
        },
      },
    );
    setSubmitting(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button type="button" variant="outline" size="sm" className="gap-1">
          <KeyRound className="size-4 shrink-0" />
          ປ່ຽນ PIN
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <form
          onSubmit={(e) => {
            void handleSubmit(e);
          }}
        >
          <DialogHeader>
            <DialogTitle>ປ່ຽນ PIN ຜູ້ຄຸ້ມຄອງ</DialogTitle>
          </DialogHeader>
          <div className="flex flex-col gap-4 py-2">
            <div className="flex flex-col gap-2">
              <Label htmlFor="admin-pin-current">PIN ປັດຈຸບັນ</Label>
              <Input
                id="admin-pin-current"
                type="password"
                autoComplete="current-password"
                inputMode="numeric"
                maxLength={PIN_MAX_LENGTH}
                value={currentPassword}
                onChange={(ev) => setCurrentPassword(ev.target.value)}
                required
              />
            </div>
            <div className="flex flex-col gap-2">
              <Label htmlFor="admin-pin-new">
                PIN ໃໝ່ ({MIN_PIN_LEN}–{PIN_MAX_LENGTH} ໂຕ)
              </Label>
              <Input
                id="admin-pin-new"
                type="password"
                autoComplete="new-password"
                inputMode="numeric"
                maxLength={PIN_MAX_LENGTH}
                value={newPassword}
                onChange={(ev) => setNewPassword(ev.target.value)}
                required
              />
            </div>
            <div className="flex flex-col gap-2">
              <Label htmlFor="admin-pin-confirm">ຢືນຢັນ PIN ໃໝ່</Label>
              <Input
                id="admin-pin-confirm"
                type="password"
                autoComplete="new-password"
                inputMode="numeric"
                maxLength={PIN_MAX_LENGTH}
                value={confirmPassword}
                onChange={(ev) => setConfirmPassword(ev.target.value)}
                required
              />
            </div>
          </div>
          <DialogFooter className="gap-2 sm:gap-0">
            <Button
              type="button"
              variant="ghost"
              onClick={() => setOpen(false)}
              disabled={submitting}
            >
              ຍົກເລີກ
            </Button>
            <Button type="submit" disabled={submitting}>
              {submitting ? "ກຳລັງບັນທຶກ…" : "ບັນທຶກ"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
